import { useLazyQuery, useQuery } from "@apollo/client";
import { DEPARTMENTS } from "../departments.queries";
import {
  DepartmentsQuery,
  DepartmentsQueryVariables,
} from "../../../__generated__/DepartmentsQuery";

export const useDepartments = () => {
  return useQuery<DepartmentsQuery, DepartmentsQueryVariables>(DEPARTMENTS, {
    variables: {
      where: {},
    },
    fetchPolicy: "network-only",
  });
};

export const useLazyDepartments = () => {
  return useLazyQuery<DepartmentsQuery, DepartmentsQueryVariables>(DEPARTMENTS);
};
